import { useLocale } from '@lessonup/client-integration';
import {
  AnchorLink,
  Banner,
  Button,
  IconCheck,
  IconSettings,
  SpaceBetween,
  spacing,
  styled,
  TextElement,
} from '@lessonup/ui-components';
import React from 'react';
import { lessonConversionArticle } from '../../../../../../utils/bridge/siteRoutes';
import { useEditorTranslation } from '../../../../hooks/useEditorTranslation';

export interface LessonConversionExplanationProps {
  onEditClick: () => void;
}

export const LessonConversionExplanation = ({ onEditClick }: LessonConversionExplanationProps) => {
  const { language } = useLocale();
  const { t } = useEditorTranslation();

  return (
    <div>
      <Banner priority="success" paragraph={t(`contextSidebar.panes.lessonConversion.banner`)} icon={<IconCheck />} />
      <TextWrapper>
        <SpaceBetween direction="y" spacing={spacing.size16}>
          <TextElement textStyle="bodyText">{t(`contextSidebar.panes.lessonConversion.p1`)}</TextElement>
          <div>
            <TextElement textStyle="bodyText" as="span">
              {t(`contextSidebar.panes.lessonConversion.p2`)}
            </TextElement>
            <TextElement textStyle="bodyText" weight="bold" as="span">
              {t(`contextSidebar.panes.lessonConversion.unsupportedComponents`)}
            </TextElement>
            <TextElement textStyle="bodyText" as="span">
              {t(`contextSidebar.panes.lessonConversion.p3`)}
            </TextElement>
          </div>
          <div>
            <TextElement textStyle="bodyText">{t(`contextSidebar.panes.lessonConversion.p4`)}</TextElement>
            <TextElement textStyle="bodyText">
              <AnchorLink href={lessonConversionArticle(language)} target="_blank">
                {t('contextSidebar.panes.lessonConversion.helpCenterArticle')}
              </AnchorLink>
            </TextElement>
          </div>
          <div>
            <Button
              buttonType="neutral"
              iconStart={<IconSettings />}
              onClick={onEditClick}
              showStroke
              resizing="hug"
              buttonShape="rect"
            >
              {t('contextSidebar.panes.lessonConversion.editLesson')}
            </Button>
          </div>
        </SpaceBetween>
      </TextWrapper>
    </div>
  );
};

const TextWrapper = styled.div`
  padding: ${spacing.size16};
`;
